import { render, staticRenderFns } from "./BirthPlaceSelect.vue?vue&type=template&id=562be4ef&"
import script from "./BirthPlaceSelect.vue?vue&type=script&lang=js&"
export * from "./BirthPlaceSelect.vue?vue&type=script&lang=js&"
import style0 from "./BirthPlaceSelect.vue?vue&type=style&index=0&id=562be4ef&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports